const googleAnalytics = () => {
  window.addEventListener('load', (event) => {
    handlePageLoad()

    const ctasButton = document.querySelectorAll('a.js-analytics-cta, button.js-analytics-cta')
    handleCtas(ctasButton)

    handleCallLinks()

    // check for carousel
    const cmpCarousel = document.querySelectorAll('.js-analytics-carousel')
    if (cmpCarousel.length > 0) {
      handleCarousel(cmpCarousel)
    }

    // Forms
    handleForms()
    handleNewsletterForm()

    // Simple search
    handleSimpleSearch()
  })
}

const googleAnalyticsSubmitForm = (form) => {
  const siteName = getSiteName()
  const urlSections = getUrlSections()

  const formCompleteFull = {
    event: 'process',
    page_view__site: siteName,
    page_view__siteSection1: urlSections.section1,
    page_view__siteSection2: urlSections.section2,
    page_view__pageName: urlSections.pageName,

    process__name: form.name ? form.name : 'newsletter-form',
    process__step: 'complete',
    process__metricComplete: 1,
    process__metricStart: ''
  }
  const formComplete = Object.fromEntries(Object.entries(formCompleteFull).filter(([_, v]) => !!v))
  console.log('GA - Form Complete', formComplete)
  window.dataLayer = window.dataLayer || []
  window.dataLayer.push(formComplete)
}
const googleAnalyticsLoadModal = (modalName) => {
  handlePageLoad(modalName)
}
function handleCarousel(cmpCarousel) {
  for (let index = 0; index < cmpCarousel.length; index++) {
    const carousel = cmpCarousel[index]
    const carouselArrows = carousel.querySelectorAll(
      'button.js-analytics-carousel-button'
    )
    carouselArrows.forEach((arrow) => {
      arrow.addEventListener('click', function (e) {
        const siteName = getSiteName()
        const urlSections = getUrlSections()

        const interactionName = urlSections.pageName + ':' + arrow.ariaLabel.toLowerCase()

        const clickOnArrowFull = {
          event: 'interaction',
          page_view__site: siteName,
          page_view__siteSection1: urlSections.section1,
          page_view__siteSection2: urlSections.section2,
          page_view__pageName: urlSections.pageName,

          interaction__type: 'carousel-nav',
          interaction__text: arrow.ariaLabel,
          interaction__name: interactionName,

          page_view__metricInstance: 1,
        }
        const clickOnArrow = Object.fromEntries(Object.entries(clickOnArrowFull).filter(([_, v]) => !!v))
        console.log('GA - Click on Carousel Arrow', clickOnArrow)
        window.dataLayer = window.dataLayer || []
        window.dataLayer.push(clickOnArrow)
      })
    })

    const carouselDots = carousel.querySelectorAll('.carousel__dots button')
    if (carouselDots.length > 0) {
      carouselDots.forEach((dot) => {
        dot.addEventListener('click', function (e) {
          const siteName = getSiteName()
          const urlSections = getUrlSections()

          const interactionName = urlSections.pageName + ':' + dot.ariaLabel.toLowerCase()

          const clickOnDotFull = {
            event: 'interaction',
            page_view__site: siteName,
            page_view__siteSection1: urlSections.section1,
            page_view__siteSection2: urlSections.section2,
            page_view__pageName: urlSections.pageName,

            interaction__type: 'carousel-nav',
            interaction__text: dot.ariaLabel,
            interaction__name: interactionName,

            page_view__metricInstance: 1,
          }
          const clickOnDot = Object.fromEntries(Object.entries(clickOnDotFull).filter(([_, v]) => !!v))
          console.log('GA - Click on Carousel dot', clickOnDot)
          window.dataLayer = window.dataLayer || []
          window.dataLayer.push(clickOnDot)
        })
      })
    }

    const carouselImageCtas = carousel.querySelectorAll(
      '.image-carousel__item-cta'
    )
    console.log('ctas', carouselImageCtas)
    if (carouselImageCtas.length > 0) {
      carouselImageCtas.forEach((cta) => {
        cta.addEventListener('click', function (e) {
          const siteName = getSiteName()
          const urlSections = getUrlSections()

          let ctaText = 'cta'
          if(cta.innerText){
            const ctaSplits = cta.innerText.split('\n')
            ctaText = ctaSplits ? fixStringForGA(ctaSplits[0]) : 'cta'
          }
          const interaction = cta.getAttribute("data-component-name") ? fixStringForGA(cta.getAttribute("data-component-name")) : cta.parentNode.className.includes('_') ? cta.parentNode.className.split('_')[0] : 'rich-text-editor'
          const interactionTitle = cta.getAttribute("data-title") ? fixStringForGA(cta.getAttribute("data-title")) : cta.parentNode.parentNode.querySelector('h1,h2,h3,h4,h5,h6,.title,.h1,.h2,.h3,.h4,.h5,.h6') ? fixStringForGA(cta.parentNode.parentNode.querySelector('h1,h2,h3,h4,h5,h6,.title,.h1,.h2,.h3,.h4,.h5,.h6').innerText) :'N/a'
          const interactionText = ctaText ? (fixStringForGA(interactionTitle) + '_' + ctaText) : fixStringForGA(interactionTitle)
          const interactionName = fixStringForGA(urlSections.pageName + ':' + interactionText)
          const interactionDestination = cta.href ? fixStringForGA(cta.href) : ctaText
          const clickInteractionFull = {
            event: 'interaction',
            page_view__site: siteName,
            page_view__siteSection1: urlSections.section1,
            page_view__siteSection2: urlSections.section2,
            page_view__pageName: urlSections.pageName,

            interaction__type: interaction,
            interaction__text: interactionText,
            interaction__name: interactionName,
            interaction__destination: interactionDestination,

            page_view__metricInstance: 1,
          }
          const clickInteraction = Object.fromEntries(Object.entries(clickInteractionFull).filter(([_, v]) => !!v))
          console.log('GA - Carousel click on image', clickInteraction)
          window.dataLayer = window.dataLayer || []
          window.dataLayer.push(clickInteraction)
        })
      })
    }
  }
}

let loaded = false;

function handlePageLoad(modalName) {
  if(!loaded){
    window.dataLayer = window.dataLayer || []

    const siteName = getSiteName()

    const urlSections = getUrlSections()
    const pageName = modalName
      ? urlSections.pageName + ':' + modalName
      : urlSections.pageName

    const pageLoadedFull = {
      event: 'page_view',
      page_view__site: siteName,
      page_view__siteSection1: urlSections.section1,
      page_view__siteSection2: urlSections.section2,
      page_view__pageName: pageName,
      page_view__metricInstance: 1,
    }
    const pageLoaded = Object.fromEntries(Object.entries(pageLoadedFull).filter(([_, v]) => !!v))
    const msg = modalName ? 'GA - Modal Loaded' : 'GA - Page Loaded'
    console.log(msg, pageLoaded)
    window.dataLayer.push(pageLoaded)
    loaded = true;
  }
}

let ctasHandled = false

function handleCtas(ctas) {
  if(!ctasHandled){
    ctas.forEach((cta) => {
      cta.addEventListener('click', function (e) {
        const siteName = getSiteName()
        const urlSections = getUrlSections()

        let ctaText = 'cta'
        if(cta.innerText){
          const ctaSplits = cta.innerText.split('\n')
          ctaText = ctaSplits ? fixStringForGA(ctaSplits[0]) : 'cta'
        }
        const interaction = cta.getAttribute("data-component-name") ? fixStringForGA(cta.getAttribute("data-component-name")) : cta.parentNode.className.includes('_') ? cta.parentNode.className.split('_')[0] : 'rich-text-editor'
        const interactionTitle = cta.getAttribute("data-title") ? fixStringForGA(cta.getAttribute("data-title")) : cta.parentNode.parentNode.querySelector('h1,h2,h3,h4,h5,h6,.title,.h1,.h2,.h3,.h4,.h5,.h6') ? fixStringForGA(cta.parentNode.parentNode.querySelector('h1,h2,h3,h4,h5,h6,.title,.h1,.h2,.h3,.h4,.h5,.h6').innerText) :'N/a'
        const interactionText = ctaText ? fixStringForGA(interactionTitle + '_' + ctaText) : fixStringForGA(interactionTitle)
        const interactionName = fixStringForGA(urlSections.pageName + ':' + interactionText)
        const interactionDestination = cta.href ? cta.href : ctaText
        const clickInteractionFull = {
          event: 'interaction',
          page_view__site: siteName,
          page_view__siteSection1: urlSections.section1,
          page_view__siteSection2: urlSections.section2,
          page_view__pageName: urlSections.pageName,

          interaction__type: interaction,
          interaction__text: interactionText,
          interaction__name: interactionName,
          interaction__destination: interactionDestination,

          page_view__metricInstance: 1,
        }
        const clickInteraction = Object.fromEntries(Object.entries(clickInteractionFull).filter(([_, v]) => !!v))
        console.log('GA - CTA click', clickInteraction)
        window.dataLayer = window.dataLayer || []
        window.dataLayer.push(clickInteraction)
      })
    })
    ctasHandled = true;
  }
}

function handleCallLinks() {
  const clickToCallLinks = document.querySelectorAll('a[href^="tel:"]')
  clickToCallLinks.forEach((callLink) => {
    callLink.addEventListener('click', function (e) {})
  })

  for (let i = 0; i < clickToCallLinks.length; i++) {
    clickToCallLinks[i].addEventListener('click', function (e) {
      let phoneNumber
      if (e.target.href === undefined) {
        phoneNumber = e.target.parentNode.href.replace('tel:', '')
      } else {
        phoneNumber = e.target.href.replace('tel:', '')
      }

      const siteName = getSiteName()
      const urlSections = getUrlSections()

      const interactionName = urlSections.pageName + ':' + ctaText.toLowerCase()

      const clickInteractionFull = {
        event: 'interaction',
        page_view__site: siteName,
        page_view__siteSection1: urlSections.section1,
        page_view__siteSection2: urlSections.section2,
        page_view__pageName: urlSections.pageName,

        interaction__type: 'click-to-call',
        interaction__text: phoneNumber,
        interaction__name: interactionName,

        page_view__metricInstance: 1,
      }
      const clickInteraction = Object.fromEntries(Object.entries(clickInteractionFull).filter(([_, v]) => !!v))
      console.log('GA - CTA click', clickInteraction)
      window.dataLayer = window.dataLayer || []
      window.dataLayer.push(clickInteraction)
    })
  }
}

function getSiteName() {
  let siteName = document.querySelector('body').dataset.layerSite
  // set default?
  siteName = siteName !== undefined ? siteName : 'rush-tc'

  return siteName
}

function getUrlSections() {
  let sections
  const cmpBreadcrumb = document.querySelector('.cmp-breadcrumb')
  const siteName = getSiteName()
  if (cmpBreadcrumb) {
    const pageSections = cmpBreadcrumb.querySelectorAll('a, span')
    const section1 = pageSections[0] ? fixStringForGA(pageSections[0].innerText) : ''
    const section2 = pageSections[1] ? fixStringForGA(pageSections[1].innerText) : ''
    const section3 = pageSections[2] ? fixStringForGA(pageSections[2].innerText) : ''
    const section4 = pageSections[3] ? fixStringForGA(pageSections[3].innerText) : ''
    const section5 = pageSections[4] ? fixStringForGA(pageSections[4].innerText) : ''
    const section6 = pageSections[5] ? fixStringForGA(pageSections[5].innerText) : ''
    const pageName =
      siteName +
      (section1 && !section1.includes('home') ? '|' + section1 : '') +
      (section2 ? '|' + section2 : '') +
      (section3 ? '|' + section3 : '') +
      (section4 ? '|' + section4 : '') +
      (section5 ? '|' + section5 : '') +
      (section6 ? '|' + section6 : '')
    if (section1.includes("home")) {
      sections = {
        section1: section2,
        section2: section3,
        pageName: pageName,
      };
    } else {
      sections = {
        section1: section1,
        section2: section2,
        section3: section3,
        pageName: pageName,
      };
    }
  } else {
    let pageSections = window.location.pathname.split('/')
    pageSections = pageSections.filter((element) => {
      return element !== ''
    })
    const section1 = pageSections[0] ? fixStringForGA(pageSections[0]) : 'home'
    const section2 = pageSections[1] ? fixStringForGA(pageSections[1]) : ''
    const section3 = pageSections[2] ? fixStringForGA(pageSections[2]) : ''
    const section4 = pageSections[3] ? fixStringForGA(pageSections[3]) : ''
    const section5 = pageSections[4] ? fixStringForGA(pageSections[4].innerText) : ''
    const section6 = pageSections[5] ? fixStringForGA(pageSections[5].innerText) : ''
    const pageName =
      siteName +
      (section1 ? '|' + section1 : '') +
      (section2 ? '|' + section2 : '') +
      (section3 ? '|' + section3 : '') +
      (section4 ? '|' + section4 : '') +
      (section5 ? '|' + section5 : '') +
      (section6 ? '|' + section6 : '')

    sections = {
      section1: section1,
      section2: section2,
      section3: section3,
      pageName: pageName,
    }
  }

  return sections
}
/* Set string to lower case and replaces empty string with hyphens  */
function fixStringForGA(string) {
  let returnString = string + ''
  returnString = returnString.toLowerCase()
  returnString = returnString.replace(/\s/g, '-')
  if(returnString.slice(-1) == '-'){
    returnString = returnString.slice(0, -1)
  }
  return returnString
}

function handleForms() {
  const form = document.getElementById('form');
  const formName = form ? (form.name ? form.name : 'form') : 'form'
  const inputs = document.querySelectorAll('form.form input[type="text"], form#form input[type="text"]')
  let started = false
  inputs.forEach((input) => {
    input.addEventListener('blur', (e) => {
      if (input.value !== '' && !started) {
        const siteName = getSiteName()
        const urlSections = getUrlSections()
        started = true

        const formStartedFull = {
          event: 'process',
          page_view__site: siteName,
          page_view__siteSection1: urlSections.section1,
          page_view__siteSection2: urlSections.section2,
          page_view__pageName: urlSections.pageName,

          process__name: formName,
          process__step: 'start',
          process__metricStart: 1,
        }
        const formStarted = Object.fromEntries(Object.entries(formStartedFull).filter(([_, v]) => !!v));
        console.log('GA - Form Started', formStarted)
        window.dataLayer = window.dataLayer || []
        window.dataLayer.push(formStarted)
      }
    })
  })
}

function handleNewsletterForm(){
  const formName = 'newsletter-form'
  const inputs = document.querySelectorAll('.newsletter__form input[type="text"]')
  let started = false
  inputs.forEach((input) => {
    input.addEventListener('blur', (e) => {
      if (input.value !== '' && !started) {
        const siteName = getSiteName()
        const urlSections = getUrlSections()
        started = true

        const formStartedFull = {
          event: 'process',
          page_view__site: siteName,
          page_view__siteSection1: urlSections.section1,
          page_view__siteSection2: urlSections.section2,
          page_view__pageName: urlSections.pageName,

          process__name: formName,
          process__step: 'start',
          process__metricStart: 1,
        }
        const formStarted = Object.fromEntries(Object.entries(formStartedFull).filter(([_, v]) => !!v));
        console.log('GA - Form Started', formStarted)
        window.dataLayer = window.dataLayer || []
        window.dataLayer.push(formStarted)
      }
    })
  })
}

function handleSimpleSearch() {
  const searchResults = document.querySelector('.search-results__state')
  if (searchResults) {
    const searchTerm = searchResults.dataset.searchTerm
    const resultsAmount = parseInt(searchResults.dataset.searchResults)
    const siteName = getSiteName()
    const urlSections = getUrlSections()

    const siteSearchFull = {
      event: 'search',
      page_view__site: siteName,
      page_view__siteSection1: urlSections.section1,
      page_view__siteSection2: urlSections.section2,
      page_view__pageName: urlSections.pageName,

      search__type: 'site-search',
      search__term: searchTerm,
      search__resultsNumber: resultsAmount,
      search__metric: 1,
    }
    const siteSearch = Object.fromEntries(Object.entries(siteSearchFull).filter(([_, v]) => !!v))
    console.log('GA - Site Search', siteSearch)
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push(siteSearch)
  }
}

const googleAnalyticsStoreLocator = (total, location) => {
  const storeLocatorDiv = document.querySelector('.store-locator-page')
  if(storeLocatorDiv){
    const searchTerm = location ? location : 'no location searched'
    const siteName = getSiteName()
    const urlSections = getUrlSections()

    const storeLoadFull = {
      event: 'search',
      page_view__site: siteName,
      page_view__siteSection1: urlSections.section1,
      page_view__siteSection2: urlSections.section2,
      page_view__pageName: urlSections.pageName,

      search__type: 'location-search',
      search__term: searchTerm,
      search__resultsNumber: parseInt(total),
      search__metric: 1,
    }
    const storeLoad = Object.fromEntries(Object.entries(storeLoadFull).filter(([_, v]) => !!v))
    console.log('GA - Store Locator', storeLoad)
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push(storeLoad)
  }
}

let firstSearch = true;
const googleAnalyticsInventorySearch = (event, total) => {
  const inventorySearchDiv = document.querySelector('.inventory-search-page')
  const params = getSearchParameters()
  let keys = {}
  let values = {}
  let refinements = ''
  Object.keys(params).forEach((prop, index)=> keys[index] = prop);
  Object.values(params).forEach((prop, index)=> values[index] = prop ? prop : 'N/A');
  Object.keys(params).forEach((prop, index)=> {
    refinements = refinements + keys[index] + '|' + values[index].replaceAll(',', '+') + ','
  });
  refinements = refinements.slice(0, -1)
  refinements = fixStringForGA(refinements);

  if(inventorySearchDiv && event === 'load'){
    const siteName = getSiteName()
    const urlSections = getUrlSections()
    const inventoryLoadFull = {
      event: 'search',
      page_view__site: siteName,
      page_view__siteSection1: urlSections.section1,
      page_view__siteSection2: urlSections.section2,
      page_view__pageName: urlSections.pageName,

      search__type: 'inventory-search',
      search__refinements: refinements,
      search__resultsNumber: parseInt(total),
      search__metric: 1,
    }
    const inventoryLoad = Object.fromEntries(Object.entries(inventoryLoadFull).filter(([_, v]) => !!v))
    inventoryLoad.search__resultsNumber ? inventoryLoad.search__resultsNumber : inventoryLoad.search__resultsNumber = 0
    console.log('GA - Inventory Search', inventoryLoad)
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push(inventoryLoad)
  }

  if(inventorySearchDiv && event === 'filter'){
    const siteName = getSiteName()
    const urlSections = getUrlSections()
    const inventoryLoadFull = {
      event: "search",
      page_view__site: siteName,
      page_view__siteSection1: urlSections.section1,
      page_view__siteSection2: urlSections.section2,
      page_view__pageName: urlSections.pageName,

      search__type: "inventory-search-refinement",
      search__refinements: refinements,
      search__resultsNumber: parseInt(total),
      search__refinementMetric: 1
    };
    if(firstSearch){
      inventoryLoadFull.search__type = "inventory-search"
      firstSearch = false
    }
    const inventoryLoad = Object.fromEntries(Object.entries(inventoryLoadFull).filter(([_, v]) => !!v))
    inventoryLoad.search__resultsNumber ? inventoryLoad.search__resultsNumber : inventoryLoad.search__resultsNumber = 0
    console.log('GA - Inventory Search', inventoryLoad)
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push(inventoryLoad)
  }
}

function getSearchParameters () {
  const url = new URL(window.location)
  let searchParams = new URLSearchParams(url.search)
  searchParams.delete('pageNumber')
  searchParams.delete('latitude')
  searchParams.delete('longitude')
  searchParams.delete('condition')
  const paramObj = {}
  for (const key of searchParams.keys()) {
      paramObj[key] = searchParams.getAll(key).length > 1
          ? searchParams.getAll(key)
          : searchParams.get(key)
  }
  return paramObj
}

export { googleAnalytics, googleAnalyticsSubmitForm, googleAnalyticsLoadModal, googleAnalyticsStoreLocator, googleAnalyticsInventorySearch }